export enum FavouriteItemActionEnum {
  Add = 'add',
  Remove = 'remove'
}
